<!--
// app/components/Shared/icons/ShirtIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 14,
  width: 14,
});
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6 12.75H1.4C1.0287 12.75 0.672601 12.592 0.41005 12.3107C0.1475 12.0294 0 11.6478 0 11.25V9.375C0 9.17609 0.0737498 8.98532 0.205025 8.84467C0.336301 8.70402 0.514348 8.625 0.7 8.625C0.978477 8.625 1.24555 8.50647 1.44246 8.2955C1.63938 8.08452 1.75 7.79837 1.75 7.5C1.75 7.20163 1.63938 6.91548 1.44246 6.7045C1.24555 6.49353 0.978477 6.375 0.7 6.375C0.514348 6.375 0.336301 6.29598 0.205025 6.15533C0.0737498 6.01468 0 5.82391 0 5.625V3.75C0 3.35218 0.1475 2.97064 0.41005 2.68934C0.672601 2.40804 1.0287 2.25 1.4 2.25H12.6C12.9713 2.25 13.3274 2.40804 13.5899 2.68934C13.8525 2.97064 14 3.35218 14 3.75V5.625C14 5.82391 13.9263 6.01468 13.795 6.15533C13.6637 6.29598 13.4857 6.375 13.3 6.375C13.0215 6.375 12.7545 6.49353 12.5575 6.7045C12.3606 6.91548 12.25 7.20163 12.25 7.5C12.25 7.79837 12.3606 8.08452 12.5575 8.2955C12.7545 8.50647 13.0215 8.625 13.3 8.625C13.4857 8.625 13.6637 8.70402 13.795 8.84467C13.9263 8.98532 14 9.17609 14 9.375V11.25C14 11.6478 13.8525 12.0294 13.5899 12.3107C13.3274 12.592 12.9713 12.75 12.6 12.75ZM1.4 10.0155V11.25H12.6V10.0155C12.0944 9.85394 11.6511 9.52186 11.3358 9.06863C11.0205 8.6154 10.8502 8.06525 10.8502 7.5C10.8502 6.93475 11.0205 6.3846 11.3358 5.93137C11.6511 5.47814 12.0944 5.14606 12.6 4.9845V3.75H1.4V4.9845C1.90556 5.14606 2.34894 5.47814 2.66421 5.93137C2.97947 6.3846 3.14976 6.93475 3.14976 7.5C3.14976 8.06525 2.97947 8.6154 2.66421 9.06863C2.34894 9.52186 1.90556 9.85394 1.4 10.0155Z"
      fill="currentColor"
    />
  </svg>
</template>

<style scoped></style>
